import { IDistributionCenterRepositoryResponse } from "@/core/repositories/lookup";
import { LookupRepository } from "@/infrastructure/repositories/lookup";

export class GetDistributionCenterUseCase {
  constructor(private readonly lookupRepository: LookupRepository) {}

  async execute(params?: { purchaserId?: number }): Promise<IDistributionCenterRepositoryResponse> {
    return this.lookupRepository.getDistributionCenters(params);
  }
}
